import { render, staticRenderFns } from "./UserViewsSelect.vue?vue&type=template&id=7820b5bd"
import script from "./UserViewsSelect.vue?vue&type=script&lang=js"
export * from "./UserViewsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports